import React from 'react';
import ErrorPageBase from './ErrorPage';

export const ErrorPage = ErrorPageBase;

export const ComingSoonPage = () => <ErrorPageBase id="coming_soon" />;

export const NotFoundpage = () => <ErrorPageBase id="not_found" />;



// WEBPACK FOOTER //
// ./src/pages/ErrorPage/errorPages.js